<template>
  <div class="layout-profile">
    <!--		<div>-->
    <!--			<img src="assets/layout/images/avatar.png" alt="" />-->
    <!--		</div>-->
    <button v-if="user" class="p-link layout-profile-link" @click="onClick">
      <span class="username">{{ user.name }} {{ user.surname }}</span>
      <i class="pi pi-fw pi-cog"></i>
    </button>
    <transition name="layout-submenu-wrapper">
      <ul v-show="expanded">
        <li>
          <button class="p-link" @click="$router.push('/account')"><i class="pi pi-fw pi-user"></i><span>{{_t('label_user_account')}}</span>
          </button>
        </li>
        <li>
          <button class="p-link" @click="logout"><i class="pi pi-fw pi-power-off"></i><span>{{_t('label_logout')}}</span></button>
        </li>
      </ul>

    </transition>
  </div>
</template>

<script>
import {logout as requestLogout} from "./api/auth";
import {deleteTableFilters} from "@/api/tableFilters";
import {clearAdminPermissions} from "@/storage/adminStorage";
import {clearAuthData, clearStoredTableFilters, getStoredUser} from "@/storage/authStorage";
import { logoutAndRedirect } from "@/router/navigationService";

export default {
  data() {
    return {
      expanded: false,
      user: {}
    }
  },
  mounted() {
    this.user = getStoredUser()
  },
  methods: {
    onClick(event) {
      this.expanded = !this.expanded;
      event.preventDefault();
    },
    logout() {
      requestLogout().then(() => {
        logoutAndRedirect(this.$router, () => {
          deleteTableFilters()
          clearAuthData()
          clearStoredTableFilters()
          clearAdminPermissions()
        })
      })
    }
  }
}
</script>
